import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

function PassengerFormOptions({ children, roomIndex, formIndex, formType, IDcard, passengerType, handleIDCardChange, selectedCountry }) {
    //general variables
    const [_, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    //sessionStorage variables
    const selectedFlight = JSON.parse(sessionStorage.getItem("selectedFlight"));

    //initial value
    useEffect(() => {
        if (formType === "flight" || formType === "hotel") {
            handleIDCardChange(formIndex, "nationalCode");
        }
    }, []);

    useEffect(() => {
        if (!!selectedCountry) {
            handleIDCardChange(formIndex, selectedCountry?.id === 1 ? "nationalCode" : "passport");
        }
    }, [selectedCountry]);

    //handle old passenger
    const handleOldPassengerChange = async (e, index, roomIndex) => {
        e.preventDefault();
        if (accessToken) {
            setSearchParams({ action: "old-passengers", index, roomIndex });
        } else {
            setSearchParams({ action: "login" });
        }
    };

    const isActive = (index, type) => (IDcard[index]?.[type] ? "active" : "");

    const renderIDCardOption = (index, type, label) => (
        <span className={`passengers-forms__ID-card ${isActive(index, type)}`} onClick={() => handleIDCardChange(index, type)}>
            {t(label)}
        </span>
    );

    const renderIDCards = index => {
        const departureType = selectedFlight?.sellingType;
        const returnType = selectedFlight?.sellingType;

        if (departureType === "Only Iranian" || returnType === "Only Iranian") {
            return renderIDCardOption(index, "nationalCode", "nationalCode");
        }

        if (departureType === "Non Iranian" || returnType === "Non Iranian") {
            return renderIDCardOption(index, "passport", "passport");
        }

        if ((departureType === "All" && returnType === "All") || (!selectedFlight && departureType === "All") || formType === "hotel") {
            return (
                <>
                    {renderIDCardOption(index, "nationalCode", "nationalCode")}
                    {renderIDCardOption(index, "passport", "passport")}
                </>
            );
        }

        return null;
    };

    return (
        <Grid container item xs={12} justifyContent="space-between" rowGap={1}>
            <Grid container item xs={8} md={6} columnGap={1} alignItems="center">
                {/* {renderIDCards(formIndex)} */}
            </Grid>
            <Grid container item xs={12} md={6} columnGap={1} justifyContent="flex-end" alignItems="center">
                {children}

                <Grid className="passengers-forms__passenger-type" component="span" container item xs="auto" display={{ xs: "none", md: "flex" }}>
                    {passengerType}
                </Grid>
                <Grid
                    className="passengers-forms__old-passenger"
                    component="span"
                    container
                    item
                    xs="auto"
                    onClick={e => handleOldPassengerChange(e, formIndex, roomIndex)}
                >
                    {t("oldPassenger")}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default PassengerFormOptions;
